import React, { useState, createContext, useContext, useEffect } from "react";
import { TruckLoader } from "../../pages/admin/truckLoader";

const loadingController = {
  activeRequestCount: 0,
  listeners: new Set(),
};

export const setGlobalApiLoading = (isLoading) => {
  if (isLoading) {
    loadingController.activeRequestCount += 1;
  } else {
    loadingController.activeRequestCount = Math.max(
      0,
      loadingController.activeRequestCount - 1
    );
  }

  const shouldShowLoader = loadingController.activeRequestCount > 0;
  loadingController.listeners.forEach((listener) => listener(shouldShowLoader));
};

export const LoaderContext = createContext();

const LoaderOverlay = () => {
  const { loading } = useContext(LoaderContext);

  if (!loading) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "transparent",
        zIndex: 1300,
        pointerEvents: "none",
      }}
    >
      <TruckLoader />
    </div>
  );
};

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const updateLoading = (isLoading) => setLoading(isLoading);
    loadingController.listeners.add(updateLoading);

    return () => {
      loadingController.listeners.delete(updateLoading);
    };
  }, []);

  const contextValue = {
    loading,
  };

  return (
    <LoaderContext.Provider value={contextValue}>
      <LoaderOverlay />
      {children}
    </LoaderContext.Provider>
  );
};
